import { render } from "./editor-text.vue?vue&type=template&id=f6fafa4a"
import script from "./editor-text.vue?vue&type=script&lang=js"
export * from "./editor-text.vue?vue&type=script&lang=js"

import "./editor-text.vue?vue&type=style&index=0&id=f6fafa4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__